import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

const Breadcrumb = ({location}) => {

  const params = useParams(); 
  const pathnames = location.pathname.split('/').filter((pathname) => pathname !== '');
  const secondTitle = pathnames[0];
  const thirdTitle = pathnames[2];

  const linkTo = params.pa ? `/${secondTitle}/${params.pa}/` : `${location.pathname}${location.hash}`
  const linkToLast = `${location.pathname}${location.hash}`

  return (

      <ul>
        <li className='breadcrum'>
          <Link to="/">inicio {'>'}</Link>
        </li>
        <li className='breadcrum'>
          <Link to={linkTo}>{secondTitle}</Link>
        </li>
        <li className='breadcrum'>
          <Link to={linkToLast} >{thirdTitle && '> '} {thirdTitle}</Link>
        </li>
      </ul>
  );
};

export default Breadcrumb;